import { useStrictContext } from '@/hooks/useStrictContext';

import { RootStoreContext } from './RootStoreContext';

export const useRootStore = () => {
  return useStrictContext({
    context: RootStoreContext,
    message: 'useRootStore must be used within a RootStoreProvider',
  });
};

export const useUserStore = () => {
  return useRootStore().userStore;
};

export const useUiStore = () => {
  return useRootStore().uiStore;
};

export const useQueryStore = () => {
  return useRootStore().queryStore;
};

export const useAlertsStore = () => {
  return useRootStore().alertsStore;
};

export const useStopwatchStore = () => {
  return useRootStore().stopwatchStore;
};
